import type React from "react";

import { Flex, Text } from "@similarweb/ui-components/foundations";

import { renderPercentageCellFactory } from "app/pages/sales-intelligence/common-components/table-cells";
import type { WebsitesDigitalAssetRecord } from "app/pages/sales-intelligence/modules/company-analysis/types/digital-assets";

type Props = {
    value: WebsitesDigitalAssetRecord["monthlyVisitsChangeMom"];
    isHeader?: boolean;
};

export const VisitsChangeCell: React.FC<Props> = ({ value, isHeader = false }) => {
    return (
        <Flex
            justifyContent="flex-end"
            {...(isHeader ? { padding: "8px 0" } : {})}
        >
            <Text fontVariant="input2">{renderPercentageCellFactory(value)}</Text>
        </Flex>
    );
};
